import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer.jsx';
import { CusFormLabel } from '../validation/Form-Components.jsx';
import Loading from '../components/Loading.jsx';
import config from '../appconfig/config.json';
import CusGreenBtn from '../components/CusGreenBtn.jsx';
import storage from '../factory/StorageFactory.js';
import mData from '../hybriddata/mainform.json';
import img1 from '../images/appCancel.png';
import losdata from '../hybriddata/loanstatusdata.json';
import nldata from '../hybriddata/nonlendingdata.json';
 
const AIPStatusReject = (props) => {
    
    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();
 
    const handleOnClick = () => {
        window.location.href = config.link.BacktoHome;
    }
 

    useEffect(() => {
        console.log('@AIPStatusReject useEffect');
 
        window.scrollTo(0, 0);
        getPropsData();
        //clearData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
      
        if (props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response : '';
            // console.log('getPropsData',resData)
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            setIsLoading(false);
        }
        else {
            //redirect to error 
            console.log('error');
        }
    }

    const isStatusUnmat= () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.AUM) {
            return true;
        }
        else {
            return false;
        }
    }

    const isStatusExpired= () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.AEX) {
            return true;
        }
        else {
            return false;
        }
    }
 
    const getStatusCodefromWAA = () => {
        const appStatusCode = response.StatusDtls.ApplicationProgress;
        // const array =appStatusCode.split('-');
        let code = appStatusCode;
        return code;
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }


    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
    <div className="container-fluid">
        <div className="outerdivsubheader">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2 className='completeTitle1 mb-0'>
                    {'Oops!'}
                    </h2>
                </div>
            </div>
        </div>
        <FormContainer>
            <div style={{ textAlign: 'center', padding: '22px'}}>
                <div>
                    <img className="imgSccS1" src={img1} alt="imgScc1" />
                </div>
                <div className='status-header-txt-reject'>
                    {isStatusUnmat()&&
                        <div>
                        {losdata.mainTitle.AUM}
                        </div>
                    }
                    {isStatusExpired()&&
                        <div>
                        <span>{losdata.mainTitle.AEX}</span><br/>
                        <span className='add-btn-blue'>{'SG.cSTP.mailbox@maybank.com'}</span>
                        </div>
                    }

                </div>
            </div>
            {isStatusExpired() &&
            <div>
                <CusGreenBtn lbtxt='Apply Now' onClick={handleOnClick}  />

                <div style={{padding: "20px 0px"}}><hr className="yellowPanelLine" /></div>

                <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center',fontWeight:'500'}}>{'For queries, get in touch at'}<br/>{'1800-MAYBANK (1800-629 2265) or (65) 6533 5229 (Overseas) '}</div>
                    </div>
                </div> 
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center'}}>{'Note: You may also visit any Maybank branch to apply.'}</div>
                        <div style={{textAlign:'center'}}>
                            <a href={config.link.branchLocator} className="txtBlue fbaPSize"> {'Click here'}</a>{' for branch locator'}
                        </div>
                    </div>
                </div> 
            </div>
            }
            {isStatusUnmat()&&
            <div>
                <div style={{ width: '100%', marginLeft: '-10px' }}>
                    <hr className="hrgoldline" />
                </div>
                <div style={{ marginLeft: '25px', margingRight: '25px' }}>

                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                        id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                        id={'uen'} name={response.StatusDtls.UEN} />

       
                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                        id={'facility'} name={response.StatusDtls.Facility} />
   

                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                        id={'financeType'} name={response.StatusDtls.FinancingType} />

   
                    <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                        id={'purpose'} name={'Property'} />
            
                    <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                        id={'combinedApp'} name={getNonLendingString()} />
                    
                    <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                        id={'date'} name={response.StatusDtls.AppDate} />
                        
                    {/* <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Approval In-Principle Expiry Date'}
                        id={'date'} name={'-'} /> */}
                </div>

                <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                    <hr className="hrgoldline" />
                </div>
                <br/>
                <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome}  />
            </div>
            }
            <br />
        </FormContainer>
        <br />
    </div>
    )
}

export default AIPStatusReject;